import { addCommasToNumber } from '@gravitate-js/excalibrr'

export function getSupplyTotal(supply: number, freight: number) {
  const total = supply + freight
  const roundedTotal = Math.round(total * 100) / 100
  const formattedTotal = addCommasToNumber(roundedTotal)

  return formattedTotal
}
